__turbopack_context__.v({
  "card": "K6mRgW_card",
  "description": "K6mRgW_description",
  "descriptionWithLists": "K6mRgW_descriptionWithLists",
  "root": "K6mRgW_root",
  "step": "K6mRgW_step",
  "stepNumber": "K6mRgW_stepNumber",
  "steps": "K6mRgW_steps",
});
